import { useState } from 'react';
import { ChatMessage } from '@ant-design/pro-chat';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import './MessageGroup.less';
import { ContentObject } from '../../../interfaces/copilotChat';
import Message from './Message';

interface MessageGroupProps {
  messages: ChatMessage[];
  isSingleItemStandalone?: boolean;
  collapsible?: boolean;
  handleArtifactClick: (artifact: ContentObject) => void;
}

const MessageGroup: React.FC<MessageGroupProps> = ({
  messages,
  isSingleItemStandalone = false,
  collapsible = true,
  handleArtifactClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (messages.length === 0) return null;
  if (messages.length === 1 && isSingleItemStandalone) {
    return (
      <Message
        message={messages[0]}
        handleArtifactClick={handleArtifactClick}
      />
    );
  }

  return (
    <div className={classNames('message-group', { collapsed: !isExpanded })}>
      {collapsible && (
        <div
          className={classNames(
            'message-group-header',
            collapsible ? 'collapsible' : 'non-collapsible'
          )}
          onClick={() => {
            setIsExpanded(!isExpanded);
          }}
        >
          <div className="header-left">
            {isExpanded ? <UpOutlined /> : <DownOutlined />}
          </div>
          <div className="header-right">
            <span className="header-title">
              {isExpanded ? 'Hide' : 'Show'} reasoning
            </span>
          </div>
        </div>
      )}

      <div className="message-group-body">
        {messages.map((message, index) => (
          <div className="message-group-item" key={message.id || index}>
            <Message
              message={message}
              handleArtifactClick={handleArtifactClick}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MessageGroup;
